module.exports = __webpack_public_path__ + "static/media/SWSCRC6-53.6339f7ef.mp3";